module.exports = "/static/img/wc.17bc451.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/login/wc.png
// module id = 181
// module chunks = 1